<template>
    <JetDialogModal :show="showModal" @close="closeModal" max-width="2xl">
        <template #title>
            Transférer le colis N°{{ currentPackage.code }} vers une autre expédition
        </template>

        <template #content>
            <div class="grid grid-cols-1 my-2">
                <div class="col-span-1">
                    <JetLabel for="travel_id" value="Expédition:" />
                    <Multiselect
                        class="mt-1"
                        id="travel_id"
                        :delay="0"
                        :minChars="1"
                        :searchable="true"
                        :valueProp="'id'"
                        :trackBy="'id'"
                        :filterResults="false"
                        :resolveOnLoad="true"
                        v-model="form.travel_id"
                        placeholder="Tapez pour rechercher une expédition disponible"
                        :options="async function(query) {
                            return await fetchTravel(query)
                        }"
                    >
                        <template v-slot:singlelabel="{ value }">
                            <div class="multiselect-single-label text-sky">
                                {{ 'Expédition N°' + value.reference + (value.container_size ? ' | Container ' + value.container_size + ' pieds' : '') }}
                            </div>
                        </template>
                        <template v-slot:option="{ option }">
                            {{ 'Expédition N°' + option.reference + (option.container_size ? ' | Container ' + option.container_size + ' pieds' : '') }}
                        </template>
                    </Multiselect>
                    <JetInputError :message="form.errors.travel_id" />
                </div>
                <div class="col-span-1 mt-4">
                    <JetLabel for="migrate_reason" value="Motif du transfert du colis:" />
                    <textarea class="form-input w-full" v-model="form.migrate_reason"
                        id="migrate_reason" cols="50" rows="4" maxlength="160"
                        placeholder="Entrer le motif du transfert du colis..."
                    ></textarea>
                    <JetInputError :message="form.errors.migrate_reason" />
                </div>
            </div>
        </template>

        <template #footer>
            <BotiButton @click="closeModal" text="Quitter" color="red">
                <template #icon><i class="fad fa-times-circle text-sm ml-1"></i></template>
            </BotiButton>

            <BotiButton :loader="form.processing" :disabled="form.processing"
                @click="migratePackage" text="Transférer le colis" color="sky"
                class="ml-2" :class="{ 'opacity-25': form.processing }"
            >
                <svg v-if="form.processing" class="animate-spin w-4 h-4 fill-current shrink-0" viewBox="0 0 16 16">
                    <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"></path>
                </svg>
                <template #icon>
                    <i class="fad fa-exchange text-sm ml-1"></i>
                </template>
            </BotiButton>
        </template>
    </JetDialogModal>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetLabel from '@/Jetstream/Label'
    import BotiButton from '@/Components/Button'
    import Multiselect from '@vueform/multiselect'
    import JetInputError from '@/Jetstream/InputError'
    import JetDialogModal from '@/Jetstream/DialogModal'

    export default defineComponent({
        components: {
            JetLabel,
            BotiButton,
            Multiselect,
            JetInputError,
            JetDialogModal
        },

        props: {
            travel: Object
        },

        data() {
            return {
                showModal: false,
                form: this.$inertia.form({
                    travel_id: null,
                    migrate_reason: null
                }),
            }
        },

        created () {
            var that = this

            this.emitter.on('showMigratePackageModal', function (evt) {
                that.showMigratePackageModal(evt)
            })
        },

        methods: {
            async fetchTravel(query) {
                const search = query === null ? '' : query
                const response = await fetch(route('travels.ajax-list') + '?search='+ search + '&forget=' + this.travel.id)

                return await response.json();
            },

            closeModal() {
                this.showModal = false
                this.form.clearErrors()
                this.form.reset()
            },

            showMigratePackageModal(currentPackage) {
                this.currentPackage = currentPackage

                this.form.travel_id = currentPackage.travel_id
                this.form.migrate_reason = currentPackage.migrate_reason

                this.showModal = true
            },

            migratePackage() {
                this.$swal.queue([{
                    title: "Colis",
                    text: "Êtes vous sûr de vouloir transférer ce colis vers une autre expédition ?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: 'rgb(110, 102, 148)',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText: "Transférer le colis",
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return this.form
                        .put(route('travels.packages.migratepackage', {travel: this.travel, package: this.currentPackage}), {
                            preserveScroll: true,
                            preserveState: true,
                            onSuccess: () =>{
                                this.closeModal()
                                this.$swal.fire(
                                    'Colis',
                                    'Colis transféré avec succès.',
                                    'success'
                                )
                            },
                            onError: (error) => {
                                this.$swal.insertQueueStep({
                                    icon: 'error',
                                    title: error.message
                                })
                            }
                        })
                    }
                }])
            },
        }
    })
</script>
